/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3VIcon24Solid = forwardRef('UiMenuDots3VIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.248 4.498a2.248 2.248 0 1 1-4.496 0 2.248 2.248 0 0 1 4.496 0Z" }),
        React.createElement("path", { d: "M14.248 12a2.248 2.248 0 1 1-4.496 0 2.248 2.248 0 0 1 4.496 0Z" }),
        React.createElement("path", { d: "M12 21.747a2.248 2.248 0 1 0 0-4.497 2.248 2.248 0 0 0 0 4.497Z" })));
});
